import { render, staticRenderFns } from "./modelView.vue?vue&type=template&id=5143b5da&scoped=true"
import script from "./modelView.vue?vue&type=script&lang=js"
export * from "./modelView.vue?vue&type=script&lang=js"
import style0 from "./modelView.vue?vue&type=style&index=0&id=5143b5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143b5da",
  null
  
)

export default component.exports